import { api } from '../../services/api';

const CONSULTING_ROLES = new Set(['consultant', 'senior_consultant']);

/**
 * Who can sit in a Consultant slot — the site's and the client's (Jim 2026-10-13 / 10-15):
 * EnviroServe consultants and senior consultants, and an inspector only when they also hold the
 * consultant role. Plain "inspector" also covers ~255 contractor inspectors brought over from the
 * legacy app, who must never be offered.
 */
export function canConsult(
  role: string | null | undefined,
  secondaryRoles: readonly string[] | null | undefined
): boolean {
  return [role, ...(secondaryRoles ?? [])].some((r) =>
    CONSULTING_ROLES.has(String(r ?? '').toLowerCase())
  );
}

export type ConsultantOption = {
  id: string;
  first_name?: string | null;
  last_name?: string | null;
  email: string;
  role?: string | null;
  secondary_roles?: string[] | null;
};

/** Active consultants, senior consultants and consulting inspectors, each once. Legacy-imported
 *  accounts are included: Jennifer Martin's came over from the legacy app (Gate 8, 10/16). */
export async function fetchConsultantOptions(): Promise<ConsultantOption[]> {
  const pages = await Promise.all(
    ['consultant', 'senior_consultant', 'inspector'].map((role) =>
      api.get<{ items: ConsultantOption[] }>(
        `/users/?role=${role}&is_active=true&include_legacy=true&size=500`
      )
    )
  );
  const seen = new Set<string>();
  return pages
    .flatMap((r) => r.data.items)
    .filter((u) => canConsult(u.role, u.secondary_roles))
    .filter((u) => (seen.has(u.id) ? false : (seen.add(u.id), true)));
}
